"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailPopup = exports.mapDispatchToProps = void 0;
var DetailNearbyFilter_1 = require("@/pages/detail/components/DetailNearbyFilter");
var DetailPopupImageGrid_1 = require("@/pages/detail/components/DetailPopupImageGrid");
var DetailPopupNearby_1 = require("@/pages/detail/components/DetailPopupNearby");
var DetailPopupStreetMap_1 = require("@/pages/detail/components/DetailPopupStreetMap");
var DetailPopupVr_1 = require("@/pages/detail/components/DetailPopupVr");
var DetailPopTabType_1 = require("@/pages/detail/states/DetailPopTabType");
var classnames_1 = require("classnames");
var React = require("react");
var DetailNearbyMore_1 = require("./DetailNearbyMore");
var DetailGalleryFloorPlanFull_1 = require("@/pages/detail/components/DetailGalleryFloorPlanFull");
var DetailGalleryPropertyFull_1 = require("@/pages/detail/components/DetailGalleryPropertyFull");
var MortgageResult_1 = require("@/pages/detail/components/MortgageResult");
var DetailPopupMortgage_1 = require("@/pages/detail/components/DetailPopupMortgage");
var DetailPopVideoPlaylist_1 = require("@/pages/detail/components/DetailPopVideoPlaylist");
var DetailPopVideoPlayer_1 = require("@/pages/detail/components/DetailPopVideoPlayer");
var DetailAction_1 = require("../actions/DetailAction");
var NearbyAction_1 = require("../actions/NearbyAction");
var react_redux_1 = require("react-redux");
var VideoAction_1 = require("../actions/VideoAction");
var mapStateToProps = function (state) { return state.detailPopup; };
// const mapStateToProps = (state: RootPageState): DetailPopupAllProp => {
//   return ({
//     popActiveTab: state.detailPopup.popActiveTab,
//     isMortgageExpand: state.detailPopup.isMortgageExpand,
//     nearbyMap: state.detailPopup.nearbyMap,
//     hasVr: state.detailPopup.hasVr,
//     hasFloorPlan: state.detailPopup.hasFloorPlan,
//     popRender: state.detailPopup.popRender,
//     videos: state.detailPopup.videos,
//     gallery: state.detailPopup.gallery,
//     galleryPhotos: state.detailPopup.galleryPhotos,
//     galleryFloorPlans: state.detailPopup.galleryFloorPlans,
//     videoPlayer: state.detailPopup.videoPlayer,
//     popNearbyTab: state.detailPopup.popNearbyTab,
//     isNearbyEstimatorShowing: state.detailPopup.isNearbyEstimatorShowing,
//     mortgage: state.detailPopup.mortgage,
//     t: state.detailPopup.t,
//     showPanel: state.detailPopup.showPanel,
//   });
// }
exports.mapDispatchToProps = function (dispatch) { return ({
    closePopup: function () { return dispatch(DetailAction_1.default.closePopup()); },
    onMenuItemClick: function (type) { return dispatch(DetailAction_1.default.onMenuItemClick(type)); },
    onGridImageClick: function (id, i, photo) { return dispatch(DetailAction_1.default.onGridImageClick(id, i, photo)); },
    onBackClick: function () { return dispatch(DetailAction_1.default.onBackClick()); },
    onMapObjectClick: function (object, i) { return dispatch(NearbyAction_1.default.onMapObjectClick(object, i)); },
    onMarkerClick: function (object, i) { return dispatch(NearbyAction_1.default.onMarkerClick(object, i)); },
    onMapObjectsClick: function (objects) { return dispatch(NearbyAction_1.default.onMapObjectsClick(objects)); },
    onFilterClick: function (filterType) { return dispatch(NearbyAction_1.default.onFilterClick(filterType)); },
    onMoreClick: function () { return dispatch(NearbyAction_1.default.onMoreClick()); },
    onPlaylistClick: function (video) { return dispatch(VideoAction_1.default.onPlaylistClick(video)); },
    onMyPlacesClick: function () { return dispatch(DetailAction_1.default.onMyPlaceClick()); },
    onAddPlaceClick: function () { return dispatch(NearbyAction_1.default.onAddPlaceClick()); },
    onMyPlaceClick: function (item, i) { return dispatch(NearbyAction_1.default.onMyPlaceClick(item, i)); },
    onPlayerClick: function () { return dispatch(VideoAction_1.default.onPlayerClick()); },
    onPlayToggle: function () { return dispatch(VideoAction_1.default.onPlayToggle()); },
    onMutedToggle: function () { return dispatch(VideoAction_1.default.onMutedToggle()); },
    onChangeStart: function () { return dispatch(VideoAction_1.default.onChangeStart()); },
    onChange: function (newCurrent) { return dispatch(VideoAction_1.default.onChange(newCurrent)); },
    onChangeEnd: function (newCurrent) { return dispatch(VideoAction_1.default.onChangeEnd(newCurrent)); },
}); };
var detailPopup = function (props) {
    var popClass = classnames_1.default([
        'l-pop',
        {
            'l-pop--active': props.popActiveTab !== DetailPopTabType_1.DetailPopTabType.NONE,
            'l-pop--panel-active': props.popActiveTab === DetailPopTabType_1.DetailPopTabType.PHOTO ||
                props.popActiveTab === DetailPopTabType_1.DetailPopTabType.FLOORPLAN ||
                props.popActiveTab === DetailPopTabType_1.DetailPopTabType.NEARBY ||
                props.popActiveTab === DetailPopTabType_1.DetailPopTabType.VIDEO ||
                props.popActiveTab === DetailPopTabType_1.DetailPopTabType.MORTGAGE,
            'l-pop--panel-reverse': props.popActiveTab === DetailPopTabType_1.DetailPopTabType.PHOTO ||
                props.popActiveTab === DetailPopTabType_1.DetailPopTabType.VIDEO ||
                props.popActiveTab === DetailPopTabType_1.DetailPopTabType.FLOORPLAN,
            'l-pop--no-panel': props.popActiveTab === DetailPopTabType_1.DetailPopTabType.STREETMAP ||
                props.popActiveTab === DetailPopTabType_1.DetailPopTabType.VR,
            'l-pop--nav-slim': props.popActiveTab === DetailPopTabType_1.DetailPopTabType.MORTGAGE,
            'l-pop--nav-calc': props.popActiveTab === DetailPopTabType_1.DetailPopTabType.MORTGAGE,
            'l-pop--nav-overlap': props.popActiveTab === DetailPopTabType_1.DetailPopTabType.PHOTO ||
                props.popActiveTab === DetailPopTabType_1.DetailPopTabType.FLOORPLAN ||
                (props.popActiveTab === DetailPopTabType_1.DetailPopTabType.NEARBY && !props.nearbyMap.big.popNearbyMore) ||
                props.popActiveTab === DetailPopTabType_1.DetailPopTabType.VR,
            'l-pop--panel-full': props.popActiveTab === DetailPopTabType_1.DetailPopTabType.PHOTO ||
                props.popActiveTab === DetailPopTabType_1.DetailPopTabType.FLOORPLAN ||
                props.nearbyMap.big.popNearbyMore ||
                (props.popActiveTab === DetailPopTabType_1.DetailPopTabType.MORTGAGE && props.isMortgageExpand),
            'l-pop--panel-half': (props.popActiveTab === DetailPopTabType_1.DetailPopTabType.NEARBY &&
                !props.nearbyMap.big.popNearbyMore) || props.popActiveTab === DetailPopTabType_1.DetailPopTabType.VIDEO,
        },
    ]);
    var renderMenuItem = function (text, type, current) {
        var onMenuItemClick = function () { return props.onMenuItemClick(type); };
        var isActive = type === current;
        var menuItemClass = classnames_1.default([
            'l-pop__menuitem',
            'c-pop__menuitem',
            {
                'l-pop__menuitem--active': isActive,
                'c-pop__menuitem--active': isActive,
                'c-pop__menuitem--alone': type === DetailPopTabType_1.DetailPopTabType.MORTGAGE,
            },
        ]);
        return (React.createElement("div", { onClick: onMenuItemClick, className: menuItemClass }, text));
    };
    var closePop = function () { return props.closePopup(); };
    var onBackClick = function () { return props.onBackClick(); };
    var onBgClicked = function (event) {
        if (event.currentTarget !== event.target)
            return;
        props.closePopup();
    };
    var hasVr = props.hasVr;
    var hasFloorPlan = props.hasFloorPlan;
    var isStreeMapDisplay = props.isStreeMapDisplay;
    return props.popRender ? (React.createElement("div", { onClick: onBgClicked, className: popClass },
        React.createElement("div", { className: "l-pop__container" },
            React.createElement("div", { className: "l-pop__nav c-pop__nav" },
                React.createElement("div", { className: "l-pop__logo" },
                    React.createElement("a", { className: "c-pop__logo", href: "/" },
                        React.createElement("img", { src: "/res/img/okay-logo-fgp-sm-inv.png" }))),
                React.createElement("div", { className: "l-pop__back" },
                    React.createElement("a", { onClick: onBackClick, className: "c-pop__back" },
                        React.createElement("span", { className: "fal fa-chevron-left" }))),
                React.createElement("div", { className: "l-pop__menu" },
                    hasVr ? renderMenuItem(props.t.virtualTour, DetailPopTabType_1.DetailPopTabType.VR, props.popActiveTab) : null,
                    props.videos && props.videos.length ? renderMenuItem(props.t.video, DetailPopTabType_1.DetailPopTabType.VIDEO, props.popActiveTab) : null,
                    renderMenuItem(props.t.photo, DetailPopTabType_1.DetailPopTabType.PHOTO, props.popActiveTab),
                    hasFloorPlan ? renderMenuItem(props.t.floorPlan, DetailPopTabType_1.DetailPopTabType.FLOORPLAN, props.popActiveTab) : null,
                    isStreeMapDisplay ? renderMenuItem(props.t.streetview, DetailPopTabType_1.DetailPopTabType.STREETMAP, props.popActiveTab) : null,
                    renderMenuItem(props.t.neighbouthood, DetailPopTabType_1.DetailPopTabType.NEARBY, props.popActiveTab),
                    renderMenuItem(props.t.mortgage, DetailPopTabType_1.DetailPopTabType.MORTGAGE, props.popActiveTab)),
                React.createElement("div", { onClick: closePop, className: "l-pop__close" },
                    React.createElement("a", { className: "c-pop__close" },
                        React.createElement("span", { className: "c-pop__close-text" }, props.t.back)))),
            React.createElement("div", { className: "l-pop__body" },
                props.showPanel || props.popActiveTab === DetailPopTabType_1.DetailPopTabType.PHOTO ? renderPanelWrap() : null,
                React.createElement("div", { className: "l-pop__contentwrap" },
                    React.createElement("div", { className: "l-pop__content" },
                        props.popActiveTab === DetailPopTabType_1.DetailPopTabType.VR
                            ? DetailPopupVr_1.renderVr(props)
                            : null,
                        props.popActiveTab === DetailPopTabType_1.DetailPopTabType.PHOTO
                            ? (React.createElement(DetailGalleryPropertyFull_1.default, __assign({}, props.galleryPhotos, { defaultAltText: props.defaultAltText })))
                            : null,
                        props.popActiveTab === DetailPopTabType_1.DetailPopTabType.VIDEO
                            ? DetailPopVideoPlayer_1.renderVideoPlayer(props, DetailPopTabType_1.DetailPopTabType.VIDEO)
                            : null,
                        props.popActiveTab === DetailPopTabType_1.DetailPopTabType.FLOORPLAN
                            ? (React.createElement(DetailGalleryFloorPlanFull_1.default, __assign({}, props.galleryFloorPlans)))
                            : null,
                        props.popActiveTab === DetailPopTabType_1.DetailPopTabType.STREETMAP
                            ? DetailPopupStreetMap_1.renderStreetMap(props.lat, props.lng)
                            : null,
                        props.popActiveTab === DetailPopTabType_1.DetailPopTabType.NEARBY
                            ? DetailPopupNearby_1.renderNearby(props.nearbyMap.big, props.onMapObjectClick, props.onMapObjectsClick, props.onMarkerClick)
                            : null,
                        props.popActiveTab === DetailPopTabType_1.DetailPopTabType.MORTGAGE
                            ? MortgageResult_1.renderMortgageResult(props)
                            : null)))))) : null;
    function renderPanelWrap() {
        return React.createElement("div", { className: "l-pop__panelwrap" },
            React.createElement("div", { className: "l-pop__panel" },
                props.popActiveTab === DetailPopTabType_1.DetailPopTabType.PHOTO
                    ? DetailPopupImageGrid_1.renderImageGrid(props, DetailPopTabType_1.DetailPopTabType.PHOTO)
                    : null,
                props.popActiveTab === DetailPopTabType_1.DetailPopTabType.VIDEO
                    ? DetailPopVideoPlaylist_1.renderVideoPlaylist(props, DetailPopTabType_1.DetailPopTabType.VIDEO)
                    : null,
                props.popActiveTab === DetailPopTabType_1.DetailPopTabType.FLOORPLAN
                    ? DetailPopupImageGrid_1.renderImageGrid(props, DetailPopTabType_1.DetailPopTabType.FLOORPLAN)
                    : null,
                props.popActiveTab === DetailPopTabType_1.DetailPopTabType.NEARBY
                    ? DetailNearbyFilter_1.renderNearbyFilter(props)
                    : null,
                props.nearbyMap.big.popNearbyMore
                    ? DetailNearbyMore_1.renderNearbyMore(props)
                    : null,
                props.popActiveTab === DetailPopTabType_1.DetailPopTabType.MORTGAGE
                    ? React.createElement(DetailPopupMortgage_1.default, null)
                    : null));
    }
};
exports.DetailPopup = detailPopup;
exports.default = react_redux_1.connect(mapStateToProps, exports.mapDispatchToProps)(detailPopup);
